<template>
  <v-app>

     <v-dialog
      v-model="spinner"
      persistent
      max-width="290"
    >
      <div class="text-xs-center spinner-wrapper">
        <v-progress-circular
          indeterminate
          color="accent"
          :size="70"
          :width="7"
          :height="90"
        ></v-progress-circular>
      </div>
    </v-dialog>


    <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
    >
      <div v-if="loading" class="text-xs-center spinner-wrapper">
        <v-progress-circular
          indeterminate
          color="primary"
          :size="70"
          :width="7"
          :height="90"
        ></v-progress-circular>
      </div>
      <v-card v-if="warning">
        <v-card-title class="headline">Switch Accounts?</v-card-title>
        <v-card-text>
          Switching accounts will change your access levels.
          Are you sure you want to switch accounts?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            flat="flat"
            @click="dialog = false; warning = false; drawerRight = false;"
          >
            No
          </v-btn>

          <v-btn
            color="primary darken-1"
            flat="flat"
            @click="switchAccount(); dialog = false; warning = false; drawerRight = false;"
          >
            Yes
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-navigation-drawer
      v-model="drawerRight"
      fixed
      temporary
      right
      app
      hide-overlay
      disable-resize-watcher
    >
      <v-list>
        <v-list-tile>
         <v-list-tile-title>
           Current Location
         </v-list-tile-title>
       </v-list-tile>
       <v-divider dark class="my-3"></v-divider>
       <v-list-tile>
         <v-list-tile-content>
           <v-list-tile-title>Locations ...</v-list-tile-title>
         </v-list-tile-content>
       </v-list-tile>
     </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer
    v-model="drawer"
    app
    fixed
    mobile-break-point="900"
    disable-resize-watcher>
      <v-list>
       <v-avatar color="primary" size="115" class="my-4">
         <img v-if="userImage" src="" alt="avatar">
         <span v-else class="white--text headline">{{userInitials}}</span>
       </v-avatar>
       <v-list-tile-title class="text-xs-center">{{userNameFirst}}</v-list-tile-title>
       <v-list-tile-sub-title class="text-xs-center mb-4">{{userEmail}}</v-list-tile-sub-title>
       <template>
          <v-list-tile :to="{name: 'Users'}" >
           <v-list-tile-action>
             <v-icon light>account_box</v-icon>
           </v-list-tile-action>
           <v-list-tile-content>
             <v-list-tile-title>Users</v-list-tile-title>
           </v-list-tile-content>
         </v-list-tile>
          <v-list-tile :to="{name: 'GiftCards'}" >
           <v-list-tile-action>
             <v-icon light>card_giftcard</v-icon>
           </v-list-tile-action>
           <v-list-tile-content>
             <v-list-tile-title>Gift Cards</v-list-tile-title>
           </v-list-tile-content>
         </v-list-tile>
         <v-list-tile :to="{name: 'Occasions'}" >
           <v-list-tile-action>
             <v-icon light>card_membership</v-icon>
           </v-list-tile-action>
           <v-list-tile-content>
             <v-list-tile-title>Occasions</v-list-tile-title>
           </v-list-tile-content>
         </v-list-tile>
         <v-list-tile :to="{name: 'CardCategories'}" >
           <v-list-tile-action>
             <v-icon light>local_offer</v-icon>
           </v-list-tile-action>
           <v-list-tile-content>
             <v-list-tile-title>Card Categories</v-list-tile-title>
           </v-list-tile-content>
         </v-list-tile>
         <v-list-tile :to="{name: 'Cards'}" >
           <v-list-tile-action>
             <v-icon light>photo_size_select_actual</v-icon>
           </v-list-tile-action>
           <v-list-tile-content>
             <v-list-tile-title>Cards</v-list-tile-title>
           </v-list-tile-content>
         </v-list-tile>
         <v-list-tile :to="{name: 'Transactions'}" >
           <v-list-tile-action>
             <v-icon light>hourglass_empty</v-icon>
           </v-list-tile-action>
           <v-list-tile-content>
             <v-list-tile-title>Transactions</v-list-tile-title>
           </v-list-tile-content>
         </v-list-tile>
         <v-list-tile :to="{name: 'SendGiftsTransactions'}" >
           <v-list-tile-action>
             <v-icon light>send</v-icon>
           </v-list-tile-action>
           <v-list-tile-content>
             <v-list-tile-title>Send Gift Transection</v-list-tile-title>
           </v-list-tile-content>
         </v-list-tile>
       </template>
     </v-list>
   </v-navigation-drawer>
   <v-toolbar class="" app color="white">
     <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
     <v-toolbar-title
      class="text-xs-right"
      v-if="$route.name==='Users'">
        Users
      </v-toolbar-title>
      <v-toolbar-title
      class="text-xs-right"
      v-if="$route.name==='GiftCards'">
        Gift Cards
      </v-toolbar-title>
      <v-toolbar-title
      class="text-xs-right"
      v-if="$route.name==='Occasions'">
        Occasions
      </v-toolbar-title>
      <v-toolbar-title
      class="text-xs-right"
      v-if="$route.name==='CardCategories'">
        Card Category
      </v-toolbar-title>
      <v-toolbar-title
      class="text-xs-right"
      v-if="$route.name==='Cards'">
        Cards
      </v-toolbar-title>
       <v-toolbar-title
      class="text-xs-right"
      v-if="$route.name==='Transactions'">
        Transactions
      </v-toolbar-title>
      <v-toolbar-title
      class="text-xs-right"
      v-if="$route.name==='SendGiftsTransactions'">
        Send Gifts Transactions
      </v-toolbar-title>
     <v-spacer></v-spacer>
     <!-- <v-toolbar-title
      class="text-xs-right">{{currentAccount.business.name}}</v-toolbar-title>
      bottom
      left-->
     <v-menu
      :close-on-content-click="false"
      :nudge-bottom="50"
      :nudge-left="50"
      :nudge-width="100"
      attach
      >
       <v-btn outline color="primary" slot="activator">
        {{currentAccount.business.name}}
       </v-btn>
       <v-card>
         <v-list>
           <v-list-tile
              v-for="(account, i) in allAccounts"
              :key="i"
              class="pointer"
              @click="switchAccountQuestion(account)"
            >
            <v-list-tile-title>
                {{ account.business.name }}
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <v-list>
          <v-list-tile @click="logout()">
            <v-list-tile-action>
              <v-icon light>exit_to_app</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Logout</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-menu>
    <v-btn icon @click.stop="drawerRight = !drawerRight">
      <v-icon>more_vert</v-icon>
    </v-btn>
    <!-- <v-toolbar-side-icon @click.stop="drawerRight = !drawerRight"></v-toolbar-side-icon> -->
   </v-toolbar>
   <v-content>
     <router-view
      @showSpinner="showSpinner()"
      @hideSpinner="hideSpinner()"
      @load="startLoad()"
      @loadEnd="endLoad()"
      @snackbar="startSnackbar"
      @expire="sessionExpire"></router-view>
     <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      >
      {{ snackMessage }}
      <v-btn
        dark
        flat
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbarLogin"
      :timeout="timeoutLogin"
    >
     Your session has expired
     <v-btn
       dark
       flat
       to="/login"
     >
       Go Login
     </v-btn>
   </v-snackbar>
   </v-content>
   <!-- <v-footer class="pa-3" app>
     <span>© 2018 - <a href="https://github.com/disjfa" class="indigo text--lighten-5">disjfa</a></span>
   </v-footer> -->
 </v-app>
</template>
<script>
import axios from 'axios';
import Env from '../environment';
import LoginFunctions from './controllers/Login';
import AuthApi from '@/components/controllers/AuthApi';

export default {
  name: 'HomeWrap',
  data: () => ({
    snackbar: false,
    snackbarLogin: false,
    timeout: 6000,
    timeoutLogin: 0,
    // if timeout: 0 snackbar will stay, for login message?
    snackMessage: 'test message',
    showSideNav: false,
    showModal: false,
    dialog: false,
    spinner: false,
    warning: false,
    loading: false,
    showModalAccount: false,
    showModalLoad: false,
    switchToAccount: {},
    userNameFirst: '',
    userNameLast: '',
    userInitials: '',
    userEmail: '',
    userImage: null,
    drawer: true,
    drawerRight: false,
  }),
  props: {
    source: String,
  },
  computed: {
    ifShowModal() {
      if (this.showModal === true) {
        return true;
      }
      return false;
    },
    allAccounts() {
      return this.$store.getters.getAccounts;
    },
    currentAccount() {
      return this.$store.getters.getActiveAccount;
    },
    permissions() {
      return this.$store.getters.getAccountPermissions;
    },
  },
  created() {
    this.startLoad();
    this.getAccounts().then((res) => {
      const data = res.data.payload.accounts;
      this.$store.dispatch('SET_ACCOUNTS', data).then(() => {
        // set default active account to first account:
        if (!this.$store.getters.getActiveAccount.business_id) {
          this.$store.dispatch('SET_ACTIVE_ACCOUNT', this.$store.getters.getAccounts[0]);
        }
      }).then(() => {
        // make api call to select user account and get a new token for that account:
        this.selectUserAccount(this.$store.getters.getActiveAccount.id)
          .then(() => {
            this.getUserInfo(this.$store.getters.getActiveAccount.user_id);
          }).then(() => {
            this.$router.push('/occasions');
            this.endLoad();
          }).catch((err) => {
            if (err.response.data.declaration === 'auth_token_needs_refresh') {
              this.sessionExpire();
            } else if (err.response.data.declaration === 'no_accounts_found') {
              this.startSnackbar('No accounts found');
            } else {
              console.log(err);
            }
          });
      });
    }).catch((err) => {
      if (err.response.data.declaration === 'auth_token_needs_refresh') {
        this.sessionExpire();
      } else if (err.response.data.declaration === 'no_accounts_found') {
        console.log('here');
      } else {
        console.log(err);
      }
    });
  },
  methods: {
    /**
    * To show snackbar.
    * @function
    * @param {string} message - The message to be displayed in snackbar
    * @returns {undefined}
    */
    startSnackbar(message) {
      this.snackMessage = message;
      this.snackbar = true;
      this.$forceUpdate();
    },
    /**
    * To show session expired snackbar.
    * @function
    * @returns {undefined}
    */
    sessionExpire() {
      this.snackbarLogin = true;
      this.dialog = true;
      this.drawer = false;
      this.drawerRight = false;
    },
    /**
    * To close session expired snackbar.
    * @function
    * @returns {undefined}
    */
    sessionExpireClose() {
      this.snackbarLogin = false;
    },
    /**
    * Get's user info.
    * @function
    * @param {integer} userID - user's ID
    * @returns {undefined}
    */
    getUserInfo(userID) {
      const accountToken = this.$store.getters.getAccountToken;
      return axios({
        method: 'GET',
        url: `${Env.url}/api/user/${userID}`,
        headers: {
          Authorization: `Bearer ${accountToken}`,
        },
      }).then((res) => {
        if (res.data.payload.user.image) {
          this.userImage = res.data.payload.user.image;
        }
        this.userNameFirst = res.data.payload.user.first_name;
        this.userNameLast = res.data.payload.user.last_name;
        this.userEmail = res.data.payload.user.email;
      }).then(() => {
        // get initials:
        this.userInitials = this.userNameFirst.substring(0, 1) + this.userNameLast.substring(0, 1);
      }).catch((err) => {
        if (err.response.data.declaration === 'auth_token_needs_refresh') {
          this.sessionExpire();
        } else {
          console.log(err);
        }
      });
    },
    /**
    * To get the apps the user has permission to use.
    * @function
    * @returns {undefined}
    */
    getMyAppsPermissions() {
      const accountToken = this.$store.getters.getAccountToken;
      return axios({
        method: 'POST',
        url: `${Env.authorization_url}/api/business/role/details/self`,
        headers: {
          Authorization: `Bearer ${accountToken}`,
        },
      });
    },
    /**
    * To select the business account to use.
    * @function
    * @param {integer} id - the business' id
    * @returns {undefined}
    */
    selectUserAccount(id) {
      const token = this.$store.getters.getToken;
      return axios({
        method: 'POST',
        url: `${Env.business_url}/api/account/login`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          account_id: id,
        },
      }).then((res) => {
        this.$store.dispatch('SET_STORAGE_ACCOUNT_TOKEN', { account_token: res.data.payload.token });
      }).then(() => {
        // this.endLoad();
        // this.getMyAppsPermissions().then((res) => {
        //   this.$store.dispatch('SET_ACCOUNT_PERMISSIONS', res.data.payload.role.permissions);
        // }).then(() => {
        //   this.endLoad();
        // });
      }).catch((err) => {
        if (err.response.data.declaration === 'auth_token_needs_refresh') {
          this.sessionExpire();
        } else {
          console.log(err);
        }
      });
    },
    /**
    * To get the business accounts that the user has access to.
    * @function
    * @returns {undefined}
    */
    getAccounts() {
      const token = this.$store.getters.getToken;
      return axios({
        method: 'POST',
        url: `${Env.business_url}/api/account/list`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    },
    /**
    * To logout.
    * @function
    * @returns {undefined}
    */

     logout() {
      /**
       * Clear storage
       */
      this.showSpinner();
      const url = `${Env.url}/api/auth/logout`;
      AuthApi.postApi(url, { clear_all_sessions: 0 })
        .then((response) => {
          if (response.data.status === 'success') {
          // On successful logout
            this.$store.dispatch('CLEAR_STORAGE');
            this.$router.push({ name: 'Login' });
             this.hideSpinner();
          } else {
            this.$store.dispatch('CLEAR_STORAGE');
            this.$router.push({ name: 'Login' });
            this.hideSpinner();
          }
        })
        .catch((err) => {
          this.$store.dispatch('CLEAR_STORAGE');
          this.$router.push({ name: 'Login' });
          this.hideSpinner();
        });
    },

    logoutOld() {
     
     
     
     
     // this.startLoad();
      // LoginFunctions.logout()
      //   .then(() => {
      //     this.$store.dispatch('CLEAR_STORAGE');
      //     this.endLoad();
      //     this.$router.push('login');
      //   }).catch((err) => {
      //     this.sessionExpire();
      //     console.log(err);
      //   });
    },
    /**
    * To show spinner icon when fetching apis
    * @function
    * @returns {undefined}
    */
    showSpinner() {
      this.spinner = true;
    },
    /**
    * To hide spinner icon after apis fetched
    * @function
    * @returns {undefined}
    */
    hideSpinner() {
      this.spinner = false;
    },

    /**
    * To start progress/loading spinner dialog.
    * @function
    * @returns {undefined}
    */
    startLoad() {
      this.dialog = true;
      this.loading = true;
    },
    /**
    * To end progress/loading spinner dialog.
    * @function
    * @returns {undefined}
    */
    endLoad() {
      const self = this;
      setTimeout(() => {
        if (!this.snackbarLogin) {
          self.dialog = false;
          self.loading = false;
        } else {
          self.loading = false;
        }
      }, 500);
      /* this.showModalLoad = this.showModal = this.showModalAccount = this.showSideNav = false */
    },
    /**
    * To ask user if they want to switch active business account.
    * @function
    * @param {Object} account - the business account to switch to
    * @returns {undefined}
    */
    switchAccountQuestion(account) {
      this.switchToAccount = account;
      this.dialog = true;
      this.warning = true;
    },
    /**
    * To switch active business account.
    * @function
    * @returns {undefined}
    */
    switchAccount() {
      this.startLoad();
      this.$store.dispatch('SET_ACTIVE_ACCOUNT', this.switchToAccount).then(() => {
        this.selectUserAccount(this.$store.getters.getActiveAccount.user_id);
      }).then(() => {
        this.$router.push('/Apps');
      });
    },
  },
};
</script>
<style>
.spinner-wrapper{
  height: 200px;
  width: auto;
}
</style>
